class SpotifyPlayer {
    constructor(playerInfo){};

}
export default SpotifyPlayer;